/** @format */

import { createFeatureSelector, createSelector } from '@ngrx/store';

import { HeaderLocation } from '@shared/data-access/interfaces';

/** @description Header Location State Selectors **/
export const selectHeaderLocationState = createFeatureSelector<HeaderLocation>('headerLocation');
export const selectUserStoreName = createSelector(
	selectHeaderLocationState,
	(state) => state.storeName
);

export const selectUserStoreInfo = createSelector(
	selectHeaderLocationState,
	(state) => state.storeInfo
);

export const selectUserStoreNumber = createSelector(
	selectUserStoreInfo,
	(storeInfo) => storeInfo?.store || storeInfo?.location
);

export const selectUserStoreZipcode = createSelector(
	selectUserStoreInfo,
	(storeInfo) => storeInfo?.zipcode || storeInfo?.zip
);

export const selectUserZipCode = createSelector(
	selectHeaderLocationState,
	(state) => state.zipCode
);

export const selectNearbyStores = createSelector(
	selectHeaderLocationState,
	(state) => state.nearbyStores
);

export const selectCrossChainBopisStoreName = createSelector(selectHeaderLocationState, (state) => {
	if (state.storeInfo?.chain === 'GOLF GALAXY') {
		return 'Golf Galaxy - ';
	} else if (state.storeInfo?.chain === 'DICKS SPORTING GOODS') {
		return "DICK'S - ";
	} else if (state.storeInfo?.chain === 'PUBLIC LANDS') {
		return 'Public Lands - ';
	}
});

const days = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];

export const selectPickupTimeText = createSelector(selectHeaderLocationState, (state) => {
	if (state.storeInfo) {
		const d = new Date();
		const day = d.getDay();
		// get current time in 24 hour format
		const currentTime = d.getHours() * 100 + d.getMinutes();

		// split time from string (ex. '0900-2100') to array (ex. ['0900', '2100'])
		const splitTime = state.storeInfo.storeHours[days[day]].split('-');
		const openTime = parseInt(splitTime[0], 10);
		const closeTime = parseInt(splitTime[1], 10);
		const oneHour = 100;

		// if current time is before one hour before open time, show ready today
		if (currentTime < openTime - oneHour) {
			return 'Ready today';
			// if current time is before one hour before close time, show ready in one hour
		} else if (currentTime < closeTime - oneHour) {
			return 'Ready within 1 hour';
			// if current time is after one hour before close, show ready tommorow
		} else {
			return 'Ready tomorrow';
		}
	}
});
